/**
 * Prefiks instalacji dla adresów budowanych w JS.
 *
 * Aplikacja może stać w podkatalogu domeny (np. maslankamragowska.pl/konkurs) — albo za proxy
 * wysyłającym X-Forwarded-Prefix. Twig radzi sobie sam (path()/asset() doklejają base path), ale
 * JS nie ma do nich dostępu, więc `<body data-base-path="…">` (patrz templates/base.html.twig)
 * publikuje ten prefiks raz, a wszystko poniżej z niego korzysta.
 *
 * Wartość to '' w rootcie domeny albo '/konkurs' w podkatalogu — bez końcowego slasha, dokładnie
 * jak Request::getBasePath().
 */
export function basePath() {
    return document.body?.dataset?.basePath ?? '';
}

/**
 * Skleja ścieżkę root-relatywną (zaczynającą się od '/') z base path instalacji.
 * `url('/api/foo')` → '/api/foo' w rootcie, '/konkurs/api/foo' w podkatalogu.
 */
export function url(path) {
    return `${basePath()}${path.startsWith('/') ? path : `/${path}`}`;
}
